import React, { useEffect, useState } from "react";
import api, { fileUrl } from "../lib/api";

const fmt = (n) => (n || 0).toLocaleString();

export default function TitlesSheet({ sessionId, open, onClose, onGetTitle }) {
  const [titles, setTitles] = useState([]);
  useEffect(() => {
    if (!open) return;
    api.get(`/live/${sessionId}/titles`).then(({ data }) => setTitles(data.titles || [])).catch(() => {});
  }, [open, sessionId]);
  if (!open) return null;
  return (
    <div className="absolute inset-0 z-40 bg-ink/80 backdrop-blur-sm flex items-end" onClick={onClose}>
      <div className="w-full bg-ink rounded-t-3xl p-5 max-h-[70vh] overflow-y-auto border-t border-white/10" onClick={(e) => e.stopPropagation()} data-testid="titles-sheet">
        <div className="flex items-center justify-between mb-1">
          <h3 className="text-cream text-2xl font-black tracking-tighter">Get a Title</h3>
          <button onClick={onClose} className="text-cream/60 text-xs tracking-[0.2em] uppercase">Close</button>
        </div>
        <p className="text-cream/50 text-xs mb-4">Earn a title by supporting this LIVE. Awarded only when the goal is truly met.</p>
        <div className="space-y-3">
          {titles.map((t) => {
            const p = t.my_progress;
            return (
              <div key={t.key} data-testid={`title-${t.key}`} className="rounded-2xl bg-white/5 border border-white/10 p-4">
                <div className="flex items-center gap-3">
                  <span className="text-2xl">{t.emoji}</span>
                  <div className="flex-1 min-w-0">
                    <p className="text-cream font-black">{t.label}</p>
                    <p className="text-cream/50 text-[11px]">{t.requirement}</p>
                  </div>
                  {t.holder ? (
                    <div className="flex flex-col items-center">
                      <div className="w-8 h-8 rounded-full overflow-hidden bg-white/15 flex items-center justify-center border border-jam-gold">
                        {t.holder.avatar_path ? <img src={fileUrl(t.holder.avatar_path)} alt="" className="w-full h-full object-cover" /> : <span className="text-cream text-xs font-black">{(t.holder.username || "?")[0]?.toUpperCase()}</span>}
                      </div>
                      <span className="text-jam-gold text-[9px] font-black mt-0.5 max-w-[64px] truncate">@{t.holder.username}</span>
                    </div>
                  ) : (
                    <span className="text-cream/40 text-[11px] font-black italic">Unclaimed</span>
                  )}
                </div>
                {p ? (
                  <>
                    <div className="h-2 rounded-full bg-white/10 overflow-hidden mt-3">
                      <div className={`h-full ${p.achieved ? "bg-jam-gold" : "bg-papaya"} transition-all`} style={{ width: `${Math.min(100, p.pct)}%` }} />
                    </div>
                    <p className="text-cream/70 text-[11px] font-bold mt-1.5">{p.achieved ? "✓ You hold this title!" : `${fmt(p.current)} / ${fmt(p.needed)} WAVE`}</p>
                  </>
                ) : null}
                {t.key === "title_gifter" && onGetTitle && !(p && p.achieved) ? (
                  <button onClick={() => { onClose(); onGetTitle(); }} data-testid="get-title-x3" className="mt-3 w-full py-2.5 rounded-full bg-jam-gold text-jam-black text-xs font-black tracking-widest">GET TITLE ×3</button>
                ) : null}
              </div>
            );
          })}
          {!titles.length ? <p className="text-cream/50 text-sm text-center py-6">No titles yet — be the first to support.</p> : null}
        </div>
      </div>
    </div>
  );
}
